import type { ImageProps } from 'next/image';
import NextImage from 'next/image';
import type { RefObject } from 'react';

type Props = ImageProps & { ref?: RefObject<HTMLImageElement | null> };

export const Image = (props: Props) => {
  return (
    <NextImage
      {...props}
      ref={props?.ref}
      placeholder={props?.placeholder || 'empty'}
      blurDataURL={
        props?.blurDataURL ||
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mM0NTIqBwACTwESUk4rbQAAAABJRU5ErkJggg=='
      }
    />
  );
};
